export const COLUMN_CONFIG = [
    {
        dataField: "firstName",
        header: "First Name",

    },
    {
        dataField: "lastName",
        header: "Last Name",

    },
    {
        dataField: "agentCode",
        header: "Agent Code",
        sort: true,
        sortKey: "agentCode",
    }

];

export const AGENT_CONFIG = [
    {
        dataField: "firstName",
        label: "First Name"
    },
    {
        dataField: "lastName",
        label: "Last Name"
    },
    {
        dataField: "agentCode",
        label: "Agent Code"
    },
    {
        dataField: "phoneNumber",
        label: "Phone Number"
    },
    {
        dataField: "agentStatus",
        label: "Agent Status"
    },
    {
        dataField: "dateCreated",
        label: "Date Created"
    }
];